<style>
@media only screen and (max-width: 850px) {
  .navbar-header .navbar-brand img {
    height: 2.308rem !important;
    max-width: 180px;
  }
}
</style>

<template>
  <div class="main-menu-wrapper">
    <div class="menu-header">
      <router-link class="menu-logo" to="/trang-chu">
        <img alt="Logo" class="img-fluid" src="@/assets/img/logo_red.png"/>
      </router-link>
      <a id="menu_close" class="menu-close" href="javascript:void(0);" @click="closeSidebar">
        <i class="fas fa-times"></i>
      </a>
    </div>
    <ul :class="styleActive">
      <template v-for="item in HeaderMenu" :key="item.tittle">
        <li v-if="item.separateRoute" :class="{ active: routeArray[1] === item.active_link }">
          <router-link :style="menuLinkStyle" :to="item.routes" @click="closeSidebar">{{ item.tittle }}</router-link>
        </li>
        <li
            v-else
            :class="{ active: routeArray[1] === item.active_link }"
            class="has-submenu"
        >
          <a :style="menuLinkStyle" href="javascript:void(0);" @click="item.showAsTab = !item.showAsTab">
            {{ item.tittle }} <i class="fas fa-chevron-down"></i>
          </a>
          <ul :class="{ 'd-block': item.showAsTab === true }" class="submenu">
            <template v-for="menu in item.menu" :key="menu.menuValue">
              <li v-if="!menu.hasSubRoute" :class="{ active: currentPath === menu.active_link }">
                <router-link :to="menu.routes" @click="closeSidebar">{{ menu.menuValue }}</router-link>
              </li>
              <li
                  v-else
                  :class="{ active: routeArray[2] === item.active_link }"
                  class="has-submenu"
              >
                <a href="javascript:void(0);">{{ menu.menuValue }}</a>
                <ul :class="{ 'd-block': menu.showSubRoute }" class="submenu">
                  <template v-for="subMenu in menu.subMenus" :key="subMenu.menuValue">
                    <li :class="{ active: currentPath === subMenu.routes }">
                      <router-link :to="subMenu.routes" @click="closeSidebar">{{ subMenu.menuValue }}</router-link>
                    </li>
                  </template>
                </ul>
              </li>
            </template>
          </ul>
        </li>
      </template>
      <li v-if="!authStore.user" class="login-link">
        <router-link to="/login" @click="closeSidebar">Đăng nhập</router-link>
      </li>
      <li v-if="!authStore.user" class="login-link">
        <router-link to="/register" @click="closeSidebar">Đăng ký</router-link>
      </li>
      <li v-if="authStore.user" class="login-link">
        <router-link to="/user/sua-thong-tin" @click="closeSidebar">Thông tin cá nhân</router-link>
      </li>
      <li v-if="authStore.user" class="login-link">
        <router-link to="/user/sua-thong-tin" @click="closeSidebar">Cài đặt</router-link>
      </li>
      <li v-if="authStore.user" class="login-link">
        <a class="logout_user" @click="authStore.logout()">Đăng xuất</a>
      </li>

    </ul>
  </div>
</template>

<script setup>
import {ref, computed, onMounted, onBeforeUnmount} from 'vue';
import {useRoute} from 'vue-router';
import HeaderMenuJson from '@/assets/json/header-menu.json';
import {useAuthStore} from "@/stores/auth";
import { isMobile } from '@/helpers/responsive';

const HeaderMenu = ref(HeaderMenuJson);
const isScrolled = ref(false);
const route = useRoute();
const isSidebarOpen = ref(true);
const authStore = useAuthStore();

const routeArray = computed(() => route.path.split('/'));
const currentPath = computed(() => route.path);

const closeSidebar = () => {
  isSidebarOpen.value = false;
  const overlay = document.querySelector('.sidebar-overlay')
  if (overlay) {
    overlay.classList.remove('opened')
  }
  document.documentElement.classList.remove('menu-opened');
};

const handleScroll = () => {
  isScrolled.value = window.scrollY > 35;
};

const menuLinkStyle = computed(() => {
  if (isMobile()) {
    return { color: 'rgb(255,255,255)' };
  }
  if (route.path !== '/trang-chu') {
    return {color: 'rgb(186,42,51)'};
  } else {
    return {color: isScrolled.value ? 'rgb(186,42,51)' : 'rgb(255,255,255)'};
  }
});

const styleActive = computed(() => {
  if (route.path !== '/trang-chu' || isScrolled.value) {
    return 'main-nav';
  }
  return 'main-nav index-main';
});


onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});
onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>